import React, { Fragment } from 'react'
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Chip
} from '@mui/material'
import {
  Business as BusinessIcon,
  Person as PersonIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  LocationOn as LocationIcon
} from '@mui/icons-material'
import { Supplier } from '../../../interfaces/Supplier/Supplier'

interface ViewSupplierProps {
  supplier?: Supplier
}

export const ViewSupplier: React.FC<ViewSupplierProps> = ({ supplier }) => {
  if (!supplier) {
    return <Typography>No hay datos del proveedor</Typography>
  }

  return (
    <Fragment>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <BusinessIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Nombre del Proveedor'
            secondary={supplier.supplierName}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PersonIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary='RUT/DNI' secondary={supplier.rutDniSupplier} />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <ScheduleIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Tolerancia en días de Recepción FEFO'
            secondary={supplier.minDaysInBound}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              {supplier.active ? <CheckCircleIcon /> : <CancelIcon />}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Estado'
            secondary={supplier.active ? 'Activo' : 'Inactivo'}
          />
        </ListItem>

        {supplier.warehouses && supplier.warehouses.length > 0 && (
          <Fragment>
            <Divider variant='inset' component='li' />
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <LocationIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary='Almacenes'
                secondary={
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '4px',
                      marginTop: '8px'
                    }}
                  >
                    {supplier.warehouses.map((warehouse, index) => (
                      <Chip
                        key={index}
                        label={warehouse.warehouseName}
                        size='small'
                        variant='outlined'
                      />
                    ))}
                  </div>
                }
              />
            </ListItem>
          </Fragment>
        )}
      </List>
    </Fragment>
  )
}
